const ageRange = [
    '18-29', '30-44', '45-59', '60+',
    '18-44', '45+'
];
export default ageRange;